/** Canonical HM Decision dashboard department names (display order). */
export const HM_DEPARTMENT_ORDER: readonly string[] = [
  'Panchayati Raj (Block) & Planning & co-ordinator',
  'RWSS',
  'Works',
  'Water Resources',
  'Rural Division',
  'H&UD',
  'Health & Family Welfare',
  'Tourism',
  'Sports',
  'Cultural',
  'High Education',
  'School Mass',
  'W&CD',
  'Revenue & Disaster Management',
] as const;

export type HmDepartmentName = (typeof HM_DEPARTMENT_ORDER)[number];

/** Map legacy / import labels → canonical department name. */
export const HM_DEPARTMENT_ALIASES: Record<string, HmDepartmentName | string> = {
  WR: 'Water Resources',
  RD: 'Rural Division',
  PWD: 'Works',
  Works: 'Works',
  'H&UD': 'H&UD',
  'Housing & Urban Development': 'H&UD',
  Sports: 'Sports',
  'Sports & Youth Services': 'Sports',
  Health: 'Health & Family Welfare',
  Tourism: 'Tourism',
  HE: 'High Education',
  'Higher Education': 'High Education',
  Education: 'High Education',
  SAM: 'School Mass',
  'Schools and Mass': 'School Mass',
  'School Mass': 'School Mass',
  WCD: 'W&CD',
  'W&CD': 'W&CD',
  Cultural: 'Cultural',
  Culture: 'Cultural',
  OLLC: 'Cultural',
  'Odia Language, Literature & Culture': 'Cultural',
  RWSS: 'RWSS',
  'PR&DW': 'Panchayati Raj (Block) & Planning & co-ordinator',
  'PR Block': 'Panchayati Raj (Block) & Planning & co-ordinator',
  'Panchayati Raj & Drinking Water': 'Panchayati Raj (Block) & Planning & co-ordinator',
  PC: 'Panchayati Raj (Block) & Planning & co-ordinator',
  'Planning & Convergence': 'Panchayati Raj (Block) & Planning & co-ordinator',
  'Rural Development': 'Rural Division',
  'Rural Division': 'Rural Division',
  'Water Resources': 'Water Resources',
  'Revenue & Disaster Management': 'Revenue & Disaster Management',
  RDM: 'Revenue & Disaster Management',
  'Revenue & DM': 'Revenue & Disaster Management',
};

export function isHmDepartmentName(name: string): name is HmDepartmentName {
  return (HM_DEPARTMENT_ORDER as readonly string[]).includes(name);
}

export function resolveHmDepartmentName(raw: string): string {
  const trimmed = (raw || '').trim();
  if (!trimmed) return trimmed;
  if (isHmDepartmentName(trimmed)) return trimmed;
  return HM_DEPARTMENT_ALIASES[trimmed] ?? trimmed;
}

export function toFirestoreDepartmentId(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
